/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseInput } from '../../models';
import { FormArrayComponent } from '../form-array/form-array.component';
import { InputLabelComponent } from '../input-label/input-label.component';
import {
    AutocompleteInputComponent,
    CheckboxInputComponent,
    ColorPickerInputComponent,
    DateInputComponent,
    FileUploadInputComponent,
    MultiSelectInputComponent,
    NopInputComponent,
    PasswordInputComponent,
    RadiosInputComponent,
    SelectInputComponent,
    SliderWithTextInputComponent,
    SwitchInputComponent,
    TextareaInputComponent,
    TextboxInputComponent
} from '../inputs';
import { ValidationInputMessagesComponent } from '../validation-input-messages/validation-input-message.component';

@Component({
    selector: 'lib-form-input',
    standalone: true,

    imports: [
        CommonModule,
        ReactiveFormsModule,
        AutocompleteInputComponent,
        CheckboxInputComponent,
        ColorPickerInputComponent,
        DateInputComponent,
        FileUploadInputComponent,
        forwardRef(() => FormArrayComponent),
        SliderWithTextInputComponent,
        InputLabelComponent,
        MultiSelectInputComponent,
        NopInputComponent,
        PasswordInputComponent,
        RadiosInputComponent,
        SelectInputComponent,
        SwitchInputComponent,
        TextareaInputComponent,
        TextboxInputComponent,
        ValidationInputMessagesComponent
    ],
    styleUrl: './form-input.component.scss',
    templateUrl: './form-input.component.html'
})
export class FormInputComponent {
    @Input() filter!: boolean;
    @Input() form!: FormGroup;
    @Input() field!: BaseInput | any;
    @Input() name!: string;
    @Input() index = 0;
}
